import { Key } from 'interface-datastore/key';
import { NotFoundError } from 'interface-store';
import { BaseDatastore } from './base.js';
export class MemoryDatastore extends BaseDatastore {
    data;
    constructor() {
        super();
        this.data = new Map();
    }
    put(key, val) {
        this.data.set(key.toString(), val);
        return key;
    }
    get(key) {
        const result = this.data.get(key.toString());
        if (result == null) {
            throw new NotFoundError();
        }
        return result;
    }
    has(key) {
        return this.data.has(key.toString());
    }
    delete(key) {
        this.data.delete(key.toString());
    }
    *_all() {
        for (const [key, value] of this.data.entries()) {
            yield { key: new Key(key), value };
        }
    }
    *_allKeys() {
        for (const key of this.data.keys()) {
            yield new Key(key);
        }
    }
}
//# sourceMappingURL=memory.js.map